import type { CustomFieldItemTreeProps } from "~/pages/Brand/Products/Details/CustomFieldGraph/custom-field-graph.types"
import { CustomFieldComponentTree } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldComponentTree"
import { CustomFieldMaterialTree } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldMaterialTree"
import { CustomFieldProductTree } from "~/pages/Brand/Products/Details/CustomFieldGraph/CustomFieldProductTree"

export const CustomFieldItemTree = ({
  product,
  root,
  getOperations,
  originCue,
}: CustomFieldItemTreeProps) => {
  if (root.kind === "material") {
    return (
      <CustomFieldMaterialTree
        product={product}
        material={root.material}
        getOperations={getOperations}
        originCue={originCue}
      />
    )
  }

  if (root.kind === "component") {
    return (
      <CustomFieldComponentTree
        product={product}
        component={root.component}
        getOperations={getOperations}
        originCue={originCue}
      />
    )
  }

  return (
    <CustomFieldProductTree
      product={product}
      getOperations={getOperations}
      originCue={originCue}
    />
  )
}
